export default __webpack_public_path__ + "static/banner-two-shape5-bf9847c7c796af4a9693ac94fa07a6cd.png";